export const environment = {
  production: true,
  baseUrl: 'https://api.scheduler.transflo.com/SchedulerAPI',
  agendaDaysToShow: 10
};
